var _ = require('underscore');
var Base = require('front/components/Base/Base');

var template = require('./TopNavDesktop.jinja');
require('./TopNavDesktop.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .TopNavDesktop-sidebarListItem--logout': 'onLogoutClick'
    },


    initialize: function (options) {
        this.options = options || {};

        app.vent.on('hide-sidebar', function () {
            this.$('.TopNavDesktop-sidebar').hide();
            this.$('.TopNavDesktop-sidebarLogo').addClass('TopNavDesktop-sidebarLogo--aboveAll');
        }.bind(this));


        Base.prototype.initialize.call(this, options);
    },


    onLogoutClick: function () {
        window.app.vent.trigger('make-logout');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/TopNav/TopNavDesktop.js
// module id = 130
// module chunks = 0